var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Archive component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconTextUnderline extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="#3F3F3F"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.23796 0.816859C6.007 0.854539 5.80003 1.01755 5.69059 1.24795L5.62788 1.37995V6.94795C5.62788 12.1645 5.63059 12.5349 5.67072 12.8159C5.77461 13.5435 5.96359 14.1629 6.27487 14.7959C6.62284 15.5038 6.93261 15.9354 7.49848 16.5013C8.06409 17.0669 8.49544 17.3765 9.20388 17.7252C10.7598 18.491 12.567 18.5861 14.1992 17.988C14.4917 17.8808 15.1423 17.5632 15.3839 17.4096C16.161 16.9155 16.9154 16.1611 17.4095 15.3839C17.5631 15.1424 17.8808 14.4918 17.9879 14.1993C18.1953 13.6333 18.317 13.0507 18.3606 12.4146C18.3783 12.1556 18.3842 10.352 18.3792 6.70795L18.3719 1.37995L18.3092 1.24795C18.1761 0.967747 17.9313 0.810619 17.6279 0.810619C17.3279 0.810619 17.0747 0.968347 16.942 1.2378L16.8839 1.35595L16.8697 6.94795C16.8618 10.0235 16.8476 12.5777 16.838 12.6239C16.8284 12.6701 16.7986 12.8213 16.7718 12.9599C16.6287 13.7005 16.2583 14.4853 15.7719 15.0784C15.5738 15.32 15.1471 15.7283 14.9039 15.909C13.6134 16.8677 11.9461 17.1257 10.4159 16.6033C9.21532 16.1936 8.19628 15.2956 7.63209 14.1503C7.46464 13.8103 7.29667 13.3156 7.22793 12.9599C7.20115 12.8213 7.17136 12.6701 7.16176 12.6239C7.15216 12.5777 7.13791 10.0235 7.13008 6.94795L7.11588 1.35595L7.06039 1.24332C6.90787 0.933643 6.57619 0.761683 6.23796 0.816859ZM2.13921 21.7234C1.96149 21.7747 1.77398 21.9386 1.67642 22.1279C1.61109 22.2547 1.58932 22.4979 1.62984 22.6484C1.69824 22.9024 1.95727 23.136 2.22184 23.1824C2.42728 23.2184 21.5725 23.2184 21.7779 23.1824C22.0425 23.136 22.3015 22.9024 22.3699 22.6484C22.4103 22.4983 22.388 22.2553 22.3216 22.1236C22.2523 21.9861 22.1042 21.8388 21.9599 21.764L21.8519 21.7079L12.0359 21.7041C5.75697 21.7016 2.19081 21.7085 2.13921 21.7234Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconTextUnderline.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconTextUnderline.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconTextUnderline.prototype, "size", void 0);
if (customElements.get('cat-icon-text-underline') === undefined) {
    customElements.define('cat-icon-text-underline', BlocksIconTextUnderline);
}
